 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app-demo/js/" + ({"about":"about","calculation":"calculation"}[chunkId]||chunkId) + "." + {"chunk-08da352e":"0a6620d7","chunk-0ba8f415":"6138daa1","chunk-107d83f4":"fe5baccc","chunk-245f0f2a":"225cde35","chunk-2b1e6468":"58c7039b","chunk-2c5e2aee":"bb74ef7f","chunk-2ea0b4a6":"e8c45873","chunk-31055005":"2b8dcfd7","chunk-3e0bf683":"6b79804a","chunk-3ffc96ac":"343ec6a2","chunk-4f691aa2":"02d1f5c6","chunk-52591a51":"53985340","chunk-52dac86f":"4f4337bf","chunk-5a6ecd2a":"0ca1c0b8","chunk-5f5a125d":"57169598","chunk-6bf9529c":"fa856c73","chunk-6ea0c9e9":"b8f22d2a","chunk-71b28fc2":"d62dc391","chunk-72fb3fc2":"52dcce8a","chunk-780047d6":"074f8b14","chunk-7f888c1a":"8c6b0b9d","chunk-9d37eef6":"e8643f23","chunk-acd37c68":"b579c05f","about":"197c7ae6","chunk-008df033":"5b9d3564","chunk-3aacb529":"e9dd1148","calculation":"80e54d97","chunk-7417c2b8":"c20176b8","chunk-910b7aa0":"c652abb3","chunk-c72e9fe0":"65b8591e","chunk-b353cf52":"37a505dc","chunk-b8135f56":"0de9b8bb","chunk-ef9c6202":"f27191b1","chunk-f02bdd3e":"1239818c","chunk-f95d1650":"3da52853","chunk-fc12f398":"375ba6a9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08da352e":1,"chunk-0ba8f415":1,"chunk-107d83f4":1,"chunk-245f0f2a":1,"chunk-2b1e6468":1,"chunk-2c5e2aee":1,"chunk-2ea0b4a6":1,"chunk-31055005":1,"chunk-3e0bf683":1,"chunk-3ffc96ac":1,"chunk-4f691aa2":1,"chunk-52591a51":1,"chunk-52dac86f":1,"chunk-5a6ecd2a":1,"chunk-5f5a125d":1,"chunk-6bf9529c":1,"chunk-6ea0c9e9":1,"chunk-71b28fc2":1,"chunk-72fb3fc2":1,"chunk-780047d6":1,"chunk-7f888c1a":1,"chunk-9d37eef6":1,"about":1,"chunk-008df033":1,"chunk-3aacb529":1,"calculation":1,"chunk-7417c2b8":1,"chunk-910b7aa0":1,"chunk-c72e9fe0":1,"chunk-b353cf52":1,"chunk-b8135f56":1,"chunk-ef9c6202":1,"chunk-f02bdd3e":1,"chunk-f95d1650":1,"chunk-fc12f398":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app-demo/css/" + ({"about":"about","calculation":"calculation"}[chunkId]||chunkId) + "." + {"chunk-08da352e":"5e5c59a1","chunk-0ba8f415":"ebeb61ca","chunk-107d83f4":"43b22d56","chunk-245f0f2a":"bfea8dcc","chunk-2b1e6468":"ac13c670","chunk-2c5e2aee":"d68e57ac","chunk-2ea0b4a6":"b4b26bbc","chunk-31055005":"e6b681e7","chunk-3e0bf683":"ae02a7be","chunk-3ffc96ac":"b1cd2525","chunk-4f691aa2":"2afe0d35","chunk-52591a51":"68d4872c","chunk-52dac86f":"6d578bd7","chunk-5a6ecd2a":"4ad067eb","chunk-5f5a125d":"fe21320b","chunk-6bf9529c":"2d055caf","chunk-6ea0c9e9":"47e0ca77","chunk-71b28fc2":"dbf555fe","chunk-72fb3fc2":"f156f1d9","chunk-780047d6":"545ac436","chunk-7f888c1a":"a300b344","chunk-9d37eef6":"ebf45f1a","chunk-acd37c68":"31d6cfe0","about":"ae2d1c00","chunk-008df033":"e8e474fd","chunk-3aacb529":"68211d00","calculation":"31a462b9","chunk-7417c2b8":"9043897c","chunk-910b7aa0":"98b4e16b","chunk-c72e9fe0":"ab5bfe31","chunk-b353cf52":"364924ad","chunk-b8135f56":"a1d401b1","chunk-ef9c6202":"ca64bf4a","chunk-f02bdd3e":"7c17f748","chunk-f95d1650":"cd3d9a6c","chunk-fc12f398":"daef24cb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
